module.exports = __webpack_public_path__ + "static/img/s_banner1.5d244dbb.jpg";